/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-media-main-video-asset-list-component.ts
 *
 * Created by randysorensen on 9/12/18.
 */

function PackageMediaMainVideoAssetListController (
    this: JS5Object,
    _: JS5Object,
    ModalService: JS5Object,
    PackageMediaService: JS5Object,
    PackageUtilService: JS5Object
) {

    this.getPackageObject = (): JS5Object => {
        return PackageMediaService.packageObject;
    };

    this.getMainVideo = (): JS5Object => {
        return PackageMediaService.getMainVideo();
    };

    this.isHdrVideo = (): boolean => {
        let acceptProfile = this.selectedVideoAcceptTemplateMember();
        return !!_.get(acceptProfile, 'acceptProfile.hdrVideoFlag');
    };

    this.hasHdrVideoXml = (): boolean => {
        return !!_.get(this.getMainVideo(), 'hdrMetadataPath');
    };

    //================//
    // Template Logic //
    //================//

    this.selectedVideoAcceptTemplateMember = (newValue: JS5Object=null) => {
        if (newValue) {
            PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember = newValue;
        }
        return PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember;
    };

    const openChangeAcceptProfileConfirmationModal = (acceptHandler: JS5Function, rejectHandler: JS5Function) => {
        ModalService.showMessageModal(
            {
                messageText:
                    `Are you sure you want to change the package's video accept profile? This will invalidate all of` +
                    ` your assets, and reintialize the view.`,
                pullCancelLeft: true,
                title: 'Change Video Accept Profile',
                windowClass: 'confirm-modal-lg',
                showOK: true
            },
            acceptHandler,
            rejectHandler);
    };

    const setNewVideoAcceptTemplateMember = () => {
        let selectedVideoAcceptTemplateMember = PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember;
        PackageMediaService.resetAllMedia();
        PackageMediaService.packageMediaData.selectedVideoAcceptTemplateMember = selectedVideoAcceptTemplateMember;

        let mainVideo = this.getMainVideo();
        _.merge(mainVideo, {
            acceptTemplateMember: selectedVideoAcceptTemplateMember,
            type: 'Video',
            role: _.find(PackageMediaService.packageMediaData.componentRoles, {isDefault: true})
        });

        PackageMediaService.packageObject.primaryAcceptTemplateMember = selectedVideoAcceptTemplateMember;
    };

    const revertOldVideoAcceptTemplateMember = () => {
        this.selectedVideoAcceptTemplateMember(this.getMainVideo().acceptTemplateMember);
    };

    this.onVideoAcceptProfileChange = () => {
        if (!PackageMediaService.hasMainVideo()) {
            setNewVideoAcceptTemplateMember();
        } else {
            openChangeAcceptProfileConfirmationModal(
                setNewVideoAcceptTemplateMember,
                revertOldVideoAcceptTemplateMember);
        }
    };

    this.getIngestPercent = () => {
        return PackageMediaService.calculateIngestPercent([this.getMainVideo()]);
    };

    this.removeHdrXml = () => {
        let mainVideo = this.getMainVideo();
        delete mainVideo.hdrMetadataAssetId;
        delete mainVideo.hdrMetadataPath;
        PackageUtilService.editorForm.$setDirty();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        PackageMediaService.getPackageMediaData().then(() => {
            this.acceptTemplateMembers = _.cloneDeep(PackageMediaService.packageMediaData.acceptTemplateMembers);
        });
    };

}

angular.module('prism-ui.package').component(
    'packageMediaMainVideoAssetList',
    {
        controller: PackageMediaMainVideoAssetListController,
        templateUrl: 'package/editor/components/view/media/assetList/videoMainAssetList/package-media-main-video-asset-list-template.html',
        bindings: {
        }
    });
